import React, { useState } from "react";
import TableCard from "../../shared/TableCard/TableCard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import Index from "./index";

export default function OrderTable({ heading, orders, loading, dispatch, search, setSearch }) {
    const { history } = Index();

    const actions = (d) => {
        return (
            <div className="flex justify-content-around gap-1">
                <i className="pi pi-eye cursor-pointer" onClick={() => history.push(`orders/details/${d._id}`)}></i>
                {/* onClick={() => history.push(`services/view/${d._id}`)} */}
            </div>
        );
    };

    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    return (
        <>
            <TableCard title={heading} onSearch={setSearch} searchKeyword={search}>
                <DataTable
                    paginator
                    value={orders}
                    selectionMode="checkbox"
                    showGridlines
                    filter={filters}
                    filterDisplay="menu"
                    rows={10}
                    loading={loading}
                    emptyMessage="No order found."
                >
                    <Column header="Order Id" field="id"></Column>
                    <Column header="Project Name" field="projectName"></Column>
                    <Column header="User Name" field="personalInfo.fullName"></Column>
                    <Column header="User Email" field="personalInfo.email"></Column>
                    <Column header="Price" body={(rowData) => "$" + rowData.totalPrice}></Column>
                    {/* <Column header="Status" body={status}></Column> */}
                    <Column header="Status" field="status"></Column>
                    <Column field="createdAt" body={(r) => formatDate(r.time)} header="Created At"></Column>
                    <Column body={actions} style={{ width: "100px" }} header="Action"></Column>
                </DataTable>
            </TableCard>
        </>
    );
}
